export class DispenseNames {
  static scheduledDispense = 'Scheduled Dispense';
  static medOrder = 'Med Order';
  static schedOrder = 'Sched Order';
  static patientEditMode = 'Edit';
  static emrNameScheduledOrder = 'ScheduledOrder';
}
